import React from 'react';
import PropTypes from 'prop-types';
import css from './ReviewSummary.module.css';
import IconCollection from '../IconCollection/IconCollection';

const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;
  const totalStars = 5;

  return Array.from({ length: totalStars }, (_, i) => {
    if (i < fullStars) {
      return <span key={i} className={css.star} aria-hidden="true">★</span>;
    } else if (i === fullStars && halfStar) {
      return <span key={i} className={css.starHalf} aria-hidden="true">☆</span>; // Could swap with a true half-star SVG
    } else {
      return <span key={i} className={css.starEmpty} aria-hidden="true">★</span>;
    }
  });
};

const ReviewSummary = ({ reviewSummary, listingTitle }) => {
  if (!reviewSummary || typeof reviewSummary.rating !== 'number' || !reviewSummary.content) return null;

  const { rating, content } = reviewSummary;
  const displayRating = rating.toFixed(1);

  return (
    <section className={css.panel} aria-label={`${listingTitle} review summary`}>
      <h4 className={css.heading}>{listingTitle} Online Review Summary</h4>
      <div className={css.summaryBox}>
        <div className={css.left}>
          <div className={css.rating} aria-label={`Rating: ${displayRating} out of 5`}>{displayRating}</div>
          <div className={css.stars} role="img" aria-label={`Star rating: ${displayRating} out of 5`}>
            {renderStars(rating)}
          </div>
          <div className={css.baseText}>Based on public reviews</div>
        </div>
        <div className={css.right}>
          <p>{content}</p>
        </div>
      </div>
      <div className={css.note}>
        <span className={css.noteIcon}>
          <IconCollection name="note" />
        </span>
        <span>
          Rating pulled from trusted public sources and automatically summarized from reviews.
        </span>
      </div>
    </section>
  );
};

ReviewSummary.propTypes = {
  reviewSummary: PropTypes.shape({
    content: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
  }),
  listingTitle: PropTypes.string.isRequired,
};

export default ReviewSummary;
